import {Dispatch, RefObject, useEffect} from 'react';
import useIsMounted from './useIsMounted';

function useDimensionsListener(ref: RefObject<HTMLElement>, onDimensionChange: Dispatch<DOMRect>) {
  const node = ref.current;
  const isMounted = useIsMounted();

  useEffect(() => {
    if (!node || !ref.current) return;

    onDimensionChange(ref.current.getBoundingClientRect());

    function resizeHandler() {
      if (isMounted.current && ref.current) {
        onDimensionChange(ref.current.getBoundingClientRect());
      }
    }

    const observer = new ResizeObserver(resizeHandler);

    observer.observe(node);
    resizeHandler();

    return () => observer.disconnect();
  }, [node, isMounted, onDimensionChange, ref]);

  useEffect(() => {
    if (ref.current) onDimensionChange(ref.current?.getBoundingClientRect());
  }, [onDimensionChange, ref]);
}

export default useDimensionsListener;
